import firebase from '../../firebase';

export default async function syncDayRides(params) {
    return firebase.functions().httpsCallable('syncDayRides')(params);
}
